import React, { useState } from 'react';
import { render } from 'react-dom';
import { useMediaQuery } from 'react-responsive';
import './index.css';

import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';

import Navbar from './SharedComponents/Navbar/Navbar.js';
import { Routes } from './routes';

import ResetScroll from './util/ResetScroll';
import PWASnackbar from './util/PWASnackbar';
import PWAPrompt from 'react-ios-pwa-prompt'

const pwaListeners = {
  onSuccess: () => {}
};

function App() {
  const [isNavOpen, setNavOpen] = useState(false);
  const toggleNav = () => setNavOpen(!isNavOpen);

  const isMobile = useMediaQuery({ maxWidth: 999 });
  return (<>
    <Router>
      <ResetScroll>
        <Navbar static={!isMobile} open={isMobile ? isNavOpen : true} callback={toggleNav}/>
        <div style={{marginLeft: isMobile ? 0 : 200, marginTop: 50}}>
          <Routes staticnav={!isMobile} callback={isMobile ? toggleNav : undefined}/>
        </div>
        <PWAPrompt
          copyBody="Download this app to your homescreen to use fullscreen and offline!"
          copyShareButtonLabel="1) Press the 'Share' button on the menu bar"
          delay={50000}
          copyClosePrompt="Close"
        />
      </ResetScroll>
    </Router>
    <PWASnackbar listeners={pwaListeners} />
  </>);
}

render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  ...pwaListeners
});
